import { UrlConstants } from "../url.constants";
export class ApiRecipientVerificationConstants {
    static URL = UrlConstants.API_V2 + "RecipientVerification";
}
